import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import i18n from "../../../i18nSetup";
import moment from "moment";
import {List, ListItem, ListItemText, Typography} from "@mui/material";
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';


import {findStopTimesForStop} from '../../actions/api'
import Divider from '@mui/material/Divider';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import Box from "@mui/material/Box";
import Modal from '@mui/material/Modal';


import {setActiveItinerary, setActiveLeg, setActiveStep, setUseRealtimeResponse} from '../../actions/narrative'
import DefaultItinerary from './default/default-itinerary'
import {getActiveSearch, getRealtimeEffects} from '../../@opentripplanner/core-utils/src/state'
import {formatTime, getTimeFormat, getRoundDuration, formatDuration} from '../../@opentripplanner/core-utils/src/time'
import ItinerarySummary from "./default/itinerary-summary";
import {pricesQuery} from "../../actions/api";
import PricesResult from '../transit-prices/prices-result'
import {calcRemainingHeight, setPriceScreen} from '../../actions/ui'
import {getFormattedStopTime} from '../viewers/stop-time';
import IconButton from "@mui/material/IconButton";
import {CURRENCY_TYPED} from '../../constants';
import {TypographyBasic} from "../../styles/components/customTypography";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import {ReactComponent as EuroIcon} from '../../assets/euro.svg';
import {ReactComponent as ShekelIcon} from '../../assets/shekel.svg'

class TabbedItineraries extends Component {
  static propTypes = {
    itineraries: PropTypes.array,
    itineraryClass: PropTypes.func,
    pending: PropTypes.bool,
    activeItinerary: PropTypes.number,
    setActiveItinerary: PropTypes.func,
    setActiveLeg: PropTypes.func,
    setActiveStep: PropTypes.func,
    setUseRealtimeResponse: PropTypes.func,
    useRealtime: PropTypes.bool,
    needFreshTimes: PropTypes.bool
  }

  static defaultProps = {
    itineraryClass: DefaultItinerary
  }

  constructor () {
    super()
    this.state = {
      isShowItinerary: false,
      isSelected: Array(3).fill(false)
    }
  }

  componentDidMount(){
    if(this.props.needFreshTimes)
        this._startAutoRefresh()
  }


  componentWillUnmount () {
    // Turn off auto refresh unconditionally (just in case).
    this._stopAutoRefresh()
  }

  _startAutoRefresh = () => {
    this._stopAutoRefresh();
    this.refreshTimer = window.setInterval(this._refreshStopTimes, 30000)
    
  }

  _stopAutoRefresh = () => {
    if(null != this.refreshTimer){
      window.clearInterval(this.refreshTimer)
      this.refreshTimer = null;
    }
  }

  _refreshStopTimes = () => {
    const { boardingStops,findStopTimesForStop } = this.props
    if(boardingStops && boardingStops.length){
        boardingStops.forEach(stopId => {
          findStopTimesForStop({stopId})
        })
    }
    
    // TODO: GraphQL approach would just call findStop again.
    // findStop({ stopId: viewedStop.stopId })

  }

  getSeperatorIfNeeded(){
    return (<div style={{paddingInlineEnd:8}}>•</div>)
  }

  renderRealtimeIfNeeded(itinerary){
    if(!this.props.needFreshTimes)
        return;
    let now  = new Date().getTime()
    const {timeFormat,stops,homeTimezone,stopViewerArriving} = this.props;
    let firstTransitLeg = itinerary.legs[0];
    if(!firstTransitLeg.transitLeg){
    if(itinerary.legs.length > 1){
      firstTransitLeg = itinerary.legs[1];
    }else{
      return
    }

    }

    if((firstTransitLeg.startTime - now) > (60*20*1000)){ // not yet boarding
      return
    }

    let boardingStop = stops[firstTransitLeg.from.stopId];
    if(!boardingStop || !boardingStop.stopTimes)
        return null
 
    let stopTimes = []
    boardingStop.stopTimes.forEach((stopTime,i) => {
        if(firstTransitLeg.routeIds.includes(stopTime.pattern.route.id.replace("1:",""))){
            stopTimes.push(...stopTime.times)
        }        
    })

    if(!stopTimes.length)
        return null;

    stopTimes.sort((a, b) => {

      const aTime = a.serviceDay + a.realtimeDeparture
      const bTime = b.serviceDay + b.realtimeDeparture
      return aTime - bTime

    })

    let result = [];

    stopTimes.forEach((stopTime,i) => {

      if(stopTime.realtimeState !== 'UPDATED')
            return;

      if(result.length > 3)
          return;
      //console.log(stopTime);
      result.push(<div key={i} style={{marginInlineEnd:8,marginTop:8,display:'flex',flexDirection:'row'}}>
      {result.length > 0 && this.getSeperatorIfNeeded()}
      {getFormattedStopTime(stopTime, homeTimezone, stopViewerArriving, timeFormat,i > 0)}
    
      </div>)
    })

    if(!result.length)
        return

    return (<div style={{display:'flex'}}>{result}</div>)


  }



  render () {
    const {
      activeItinerary,
      itineraries,
      itineraryClass,
      realtimeEffects,
      useRealtime,
      prices,
      isShowPriceScreen,
      isShowShekelBtn,
      dir,
      config
    } = this.props
    if (!itineraries) return null

    const getCurrencySymbol = () => {
      switch (config.currency) {
        case CURRENCY_TYPED.euro:
          return <EuroIcon/>;
        case CURRENCY_TYPED.shekel:
          return <ShekelIcon/>;
        default:
          return <ShekelIcon/>;
      }
    };

    const selectRoute = (itinerary, index) => {
      this.props.setActiveItinerary(index);
      if (this.props.onItinerarySelected) {
        this.props.onItinerarySelected(itinerary);
        return;
      }

      if (this.state.isSelected[index] === false) {
        this.setState({isShowItinerary: true})
      } else {
        this.setState({isShowItinerary: !this.state.isShowItinerary})
      }

      let newIsSelected = Array(3).fill(false);
      newIsSelected[index] = true;
      this.setState({isSelected: newIsSelected})
    };

    /* TODO: should this be moved? */
    const showRealtimeAnnotation =
      realtimeEffects.isAffectedByRealtimeData && (
        realtimeEffects.exceedsThreshold ||
        realtimeEffects.routesDiffer ||
        !useRealtime
      );
    return (
      <>
        <List sx={{
          overflow: 'auto',
          maxHeight: calcRemainingHeight('tabbed-itineraries', 200)
        }}>
          {itineraries.map((itinerary, index) => {
            /*const timeOptions = {
              format: timeFormat,
              offset: getTimeZoneOffset(itinerary)
            }*/
            const classNames = ['tab-button', 'clear-button-formatting']
            //    const {caloriesBurned} = calculatePhysicalActivity(itinerary)
            /*   const {
                 minTNCFare,
                 transitFare
               } = calculateFares(itinerary)*/
      // TODO: support non-USD
  //    let minTotalFare = minTNCFare * 100 + transitFare
     // const plus = maxTNCFare && maxTNCFare > minTNCFare ? '+' : ''
      if (index === activeItinerary) classNames.push('selected')
      const roundDuration = getRoundDuration(itinerary.duration)
      let isToday = moment(itinerary.startTime).isSame(moment(), 'day');
      return (
        <div key={'tabbedItinerary' + index}>
          {index == 0 &&   <Divider flexItem/>}
          <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center'}}>
            <ListItem sx={{
              paddingRight: 'unset',
              paddingLeft: 'unset',
              backgroundColor: "transparent",
              "&.Mui-selected": {
                backgroundColor: "transparent"
              },
              "&.Mui-selected:hover": {
                backgroundColor: "transparent"
              }
            }}
                      selected={this.state.isSelected[index]}>
              <Grid container>
                <Grid item xs={10}>
                  <Stack direction="row" spacing={1} alignItems="center" onClick={() => {
                    selectRoute(itinerary, index)
                  }}>
                    <IconButton>
                      {this.state.isSelected[index] && this.state.isShowItinerary ? <ExpandLess/> :
                        <ExpandMore/>}</IconButton>
                    <Box sx={{maxWidth: '50px', minWidth: '50px'}}>
                      <ListItemText primary={roundDuration.value} secondary={i18n.t(roundDuration.type)}/>
                    </Box>
                    <div className={`option default-itin`}>
                      <div
                        className='header'
                      >
                        <ItinerarySummary itinerary={itinerary}/>
                        <span
                          className='arrivalTime'>{(isToday ? "" : (moment(itinerary.startTime).calendar().split(" ")[0] + " ")) + formatTime(itinerary.startTime)}—{formatTime(itinerary.endTime)}</span>
                        {this.renderRealtimeIfNeeded(itinerary)}
                      </div>
                    </div>
                  </Stack>
                </Grid>
                <Grid item xs={2} display="flex" justifyContent="center" alignItems="center">
                  {(config.showTransitPriceButton && isShowShekelBtn && !isShowPriceScreen && ((itinerary.legs.length > 1) || (itinerary.legs[0].transitLeg === true))) &&
                  <Box>
                    <IconButton onClick={() => {
                      this.props.calcPrices(itinerary)
                      this.props.setPriceScreen(true)
                    }}>
                      {getCurrencySymbol()}
                    </IconButton>
                  </Box>
                  }
                </Grid>
              </Grid>
            </ListItem>
            {(prices && isShowPriceScreen) &&
            <Modal
              open={isShowPriceScreen}
              aria-labelledby="simple-modal-title"
              aria-describedby="simple-modal-description"
            >
              <Box sx={{
                minWidth: 320, backgroundColor: 'white',
                position: 'absolute',
                left: '50%',
                top: '50%',
                transform: 'translate(-50%, -50%)',
                width: '50%',
                overflowY: 'scroll',
                maxHeight: 640
              }}>
                <PricesResult textEndBtn={i18n.t('close')}/>
              </Box>
            </Modal>
            }
          </div>

            {(activeItinerary !== null && this.state.isShowItinerary && this.state.isSelected[index]) &&
            <div>
              {React.createElement(itineraryClass, {
                itinerary: itineraries[activeItinerary],
                index: activeItinerary,
                key: activeItinerary,
                active: true,
                routingType: 'ITINERARY',
                dir,
                showRealtimeAnnotation,
                ...this.props
              })}
            </div>
            }
            <Divider flexItem/>
          </div>
      )
    })}

  </List>
</>
    )
  }
}

// connect to the redux store

const mapStateToProps = (state, ownProps) => {
  const activeSearch = getActiveSearch(state.otp)
  // const { activeItinerary, activeLeg, activeStep } = activeSearch ? activeSearch.activeItinerary : {}
  const pending = activeSearch ? activeSearch.pending : false
  const realtimeEffects = getRealtimeEffects(state.otp)
  const useRealtime = state.otp.useRealtime
  return {
    // swap out realtime itineraries with non-realtime depending on boolean
    pending,
    realtimeEffects,
    activeItinerary: activeSearch && activeSearch.activeItinerary,
    activeLeg: activeSearch && activeSearch.activeLeg,
    activeStep: activeSearch && activeSearch.activeStep,
    useRealtime,
    companies: state.otp.currentQuery.companies,
    tnc: state.otp.tnc,
    timeFormat: getTimeFormat(state.otp.config),
    prices:state.otp.activeItineraryPrices,
    isShowPriceScreen:state.otp.ui.isShowPriceScreen,
    boardingStops:activeSearch && activeSearch.response && activeSearch.response.plan && activeSearch.response.plan.boardingStops,
    stops:state.otp.transitIndex.stops,
    homeTimezone: state.otp.config.homeTimezone,
    stopViewerArriving: state.otp.config.language.stopViewerArriving,
    config: state.otp.config
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    findStopTimesForStop: (stopId) => {
        dispatch(findStopTimesForStop(stopId))
    },
    setActiveItinerary: index => {
      dispatch(setActiveItinerary({index}))
    },
    setActiveLeg: (index, leg) => {
      dispatch(setActiveLeg({index, leg}))
    },
    setActiveStep: (index, step) => {
      dispatch(setActiveStep({index, step}))
    },
    setUseRealtimeResponse: ({useRealtime}) => {
      dispatch(setUseRealtimeResponse({useRealtime}))
    },
    calcPrices: (itinerary) => { dispatch(pricesQuery(itinerary)) },
    setPriceScreen: (x) => { dispatch(setPriceScreen(x)) }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(
  TabbedItineraries
)
